import axios from "axios";
import React, { useEffect, useState } from "react";
import { JwtDecoder } from "../../Utils/JwtDecoder";
import { UserPosts } from "./UserPosts";
import { useNavigate } from "react-router-dom";
import base_url from "../../Utils/server";
import { toast } from "react-toastify";

export const AdminPanel = () => {
  const [postStats, setPostStats] = useState(0);
  const Token = sessionStorage.getItem("jwtToken");
  const url = `${base_url}/all/posts/`;
  const [userStats, setUserStats] = useState(0);
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const [matchArray, setMatchArray] = useState(posts);
  useEffect(() => {
    axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if(res.data.status=="success"){
          setPosts(res.data.data);
          setMatchArray(res.data.data);
        }
        else{
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        toast.error("Error fetching posts");
      });
    }, []);
    useEffect(() => {}, [posts]);
    useEffect(() => {
      axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if(res.data.status=="success"){
          setPostStats(res.data.count);
        }
        else{
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        toast.error("Error fetching stats");
      });
      axios
      .get(`${base_url}/getallappusers`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if(res.data.status=="success"){
          setUserStats(res.data.count);
        }
        else{
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        toast.error("Error fetching stats");
      });
  }, []);
  return (
    <>
      <section className="py-14">
        <div className="max-w-screen-xl mx-auto px-4 text-gray-600 md:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl">
              Our customers are always happy
            </h3>
          </div>
          <div className="mt-12">
            <ul className="flex flex-col items-center justify-center gap-y-10 sm:flex-row sm:flex-wrap lg:divide-x">
              <li className="text-center px-12 md:px-16">
                <h4 className="text-4xl text-indigo-600 font-semibold">
                  {userStats>0 ?userStats : "45"}+
                </h4>
                <p className="mt-3 font-medium">Users</p>
              </li>
              <li className="text-center px-12 md:px-16">
                <h4 className="text-4xl text-indigo-600 font-semibold">
                  {postStats>0 ?postStats : "65"}+
                </h4>
                <p className="mt-3 font-medium">Posts</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div className="-mx-40 fixed w-screen">
        <UserPosts
          posts={posts}
          setPosts={setPosts}
          matchArray={matchArray}
          setMatchArray={setMatchArray}
          url={url}
        />
      </div>
      <button
        onClick={() => {
          navigate("/profile");
        }}
        className="ml-1 mt-6 fixed top-0 left-10 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
      >
        Back to Profile
      </button>
    </>
  );
};
